<template>
  <!-- <div>
    <b-jumbotron>
    <h3>
      
    </h3>
    
    <hr class="my-4" >
    
  </b-jumbotron> -->

  <b-container>
    <b-row>
      <b-col cols="12">
        <p class="text-justify text-wrap px-5">
          <h1> Política de Privacidade </h1>
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <p class="text-justify text-wrap px-5">
          Este documento visa registrar a manifestação livre, informada e inequívoca pela qual o Titular concorda com o tratamento de seus dados pessoais para finalidade determinada, em conformidade com a Lei nº 13.709 – Lei Geral de Proteção de Dados Pessoais (LGPD). Ao manifestar sua aceitação para com o presente termo, o Titular consente e concorda que a MARIA BAILARINA, CNPJ nº 27.067.334/0001-39, com sede na Cidade de Campo Mourão- PR/Brasil, e-mail mariabailarinafinanceiro@gmail.com, realize o tratamento dos dados pessoais com a finalidade de cadastrar o titular como responsável por um aluno(a) matriculado(a).
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <p class="text-justify text-wrap px-5">
          Estou ciente que nos termos da Lei nº 13.709, de 14 de agosto de 2018, meus dados serão mantidos em formato interoperável com a finalidade de cadastro privado. Tomei conhecimento que tenho direito a obter da Maria Bailarina a qualquer momento e mediante requerimento, as seguintes informações sobre meus dados por ela tratados, com exceção daqueles que assegurem a segurança do Estado e da sociedade, na Nome Completo do Titular: Documento de Identidade: CPF: Dados pessoais Finalidade Forma do tratamento: Duração do tratamento: Compartilhamento previsto: Legislação forma do artigo 23, da Lei no 12.527, de 18 de novembro de 2011 (Lei de Acesso à Informação): a) confirmação da existência de tratamento; b) acesso aos dados; c) correção de dados incompletos, inexatos ou desatualizados; d) informação das entidades públicas e privadas com as quais o controlador realizou uso compartilhado de dados; e) anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade com o disposto na Lei nº 13.709; f) portabilidade dos dados a outro fornecedor de serviço ou produto, mediante requisição expressa, de acordo com a regulamentação da autoridade nacional, observados os segredos comercial e industrial; g) eliminação dos dados pessoais tratados com o consentimento do titular, exceto nas hipóteses previstas no art. 16 da Lei nº 13.709; h) informação sobre a possibilidade de não fornecer consentimento e sobre as consequências da negativa; i) revogação do consentimento, estando ciente que tal revogação impossibilita a manutenção do cadastro de usuário externo em sistema informatizado de gestão de documentos.
        </p>
      </b-col>
    </b-row>
  </b-container>


  <!-- </div> -->
</template>

<script>


export default {
  name: "termos",
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/termos.vue